import { Theme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';

import { MOBILE_APP_CLUB_CODE } from '../constants/mobileApp';
import { getThemeForClub } from '../styles/themes';

const useClubTheme = (): Theme => {
  const [clubCode] = useSessionStorage(MOBILE_APP_CLUB_CODE, '');

  const theme = useMemo(() => getThemeForClub(clubCode), [clubCode]);

  return theme;
};

export default useClubTheme;
